import { streamerApi } from '@/pages/Donation/api/streamer'
import { DonationType, IDonation, IPayment, PaymentType } from '@/pages/Donation/api/streamer/types'
import { FormValues } from '@/pages/Donation/types'
import { formatYoutubeLink } from '@/pages/Donation/utils'

type GetDonationParamsProps = {
  values: FormValues
  origin: string
}

// eslint-disable-next-line complexity
export const getDonationParams = ({ values, origin }: GetDonationParamsProps): IDonation => {
  const isFiat = values.paymentType === PaymentType.Fiat
  const fiatPaymentMethod = values.selectedFiatProvider?.payment_method ?? null
  const fiatProvider = values.selectedFiatProvider?.provider ?? null
  const fiatAmount = values.fiatAmount?.toString() ?? null
  const cryptoAssetCode = values.selectedCryptoAsset?.code ?? null
  const cryptoNetworkCode = values.selectedNetwork?.code ?? ''
  const isIncludeFee = values.isIncludeFee ?? null
  const baseCurrency = values?.baseCurrency?.code ?? null
  const goalId = values?.goal === 'None' ? null : (values?.goal ?? null)

  const payment: IPayment = {
    type: values.paymentType,
    currency: baseCurrency,
    amount: fiatAmount,
    crypto_coin: isFiat ? null : cryptoAssetCode,
    crypto_network_code: isFiat ? null : cryptoNetworkCode,
    cover_fee: isFiat ? null : isIncludeFee,
    fiat_payment_method: isFiat ? fiatPaymentMethod : null,
    fiat_provider: isFiat ? fiatProvider : null,
    fiat_country: isFiat ? values.country : null,
    fiat_state: isFiat ? (values.state ?? undefined) : undefined,
  }

  const { link: formattedVideoLink, timestamp: formattedVideoStart } =
    formatYoutubeLink(values.youtubeLink, values.youtubeStart) ?? {}

  const commonParams = {
    donation_type: values.donationType,
    origin,
    payment,
    donator_name: !values.name || values.isAnon ? null : values.name,
    video_src: formattedVideoLink ?? null,
    video_start_from: formattedVideoStart ?? null,
    image_asset_id: values.image ?? null,
    goal_id: goalId,
  }

  if (values.donationType === DonationType.Text) {
    return {
      ...commonParams,
      tts_name: values.voice?.name ?? null,
      donation_text: values.message ?? null,
    }
  }

  return {
    ...commonParams,
    tts_name: null,
    donation_text: null,
  }
}

type PostDonationProps = {
  values: FormValues
  username?: string
  origin: string
}

export const postDonation = ({ values, username, origin }: PostDonationProps) => {
  const isInvalidParams = !username

  if (isInvalidParams) {
    throw Error()
  }

  const donationParams = getDonationParams({ values, origin })

  const formData = new FormData()

  formData.append('donation', JSON.stringify(donationParams))

  if (values.donationType === DonationType.Audio && values.audio) {
    formData.append('audio', values.audio)
  }

  return streamerApi.postDonate(username, formData)
}
